// v2 = the same handlers behind the gateway captcha (services/captcha).
export const LOGIN = '/api/v2/user/login';
export const LOGIN_OTP = '/api/v1/user/verify/mfa';
export const LOGIN_RESEND_OTP = '/api/v2/user/mfa/send';
export const REGISTER = '/api/v2/user/register';
export const REGISTER_OTP = '/api/v1/user/register/verify';
export const REGISTER_RESEND_OTP = '/api/v2/user/register/sms/resend';
export const GOOGLE_SIGN_IN = '/api/v1/user/google/sign-in';
export const GOOGLE_REGISTER = '/api/v1/user/google/register';
export const GENERATE_QR_CODE = '/api/v1/user/qrcode/login/generate';
export const LOGIN_WITH_QR = '/api/v1/user/qrcode/login/query';
export const PASSWORD_OTP = '/api/v2/user/password/forget/send';
export const PASSWORD_OTP_VERIFY = '/api/v1/user/password/forget/verify';
export const PASSWORD_CHANGE = '/api/v1/user/password/forget/change';

/**
 * RTK Query endpoints of the login, register and forgot-password flows. A 401 from these means a
 * wrong password or code (or an expired step), not an expired session, so the 401 handlers leave
 * them to the page instead of refreshing and logging the user out.
 */
export const AUTH_FLOW_ENDPOINTS = new Set([
  'login',
  'loginOTP',
  'loginResendOTP',
  'register',
  'registerOTP',
  'registerResendOTP',
  'passwordOTP',
  'passwordOTPVerify',
  'passwordChange'
]);
